module.exports = __webpack_public_path__ + "img/sintesis01.be65d11e.png";